<div class="heading">
    Proof of Residence
</div>

<div class="secondary-text">
    You have to upload a soft-copy of the selected address proof in the next step. Please ensure that the address is
    clearly visible. Field verification will be done at this address.
</div>

<form [formGroup]="residenceProofFormGroup" (ngSubmit)="onSubmit(residenceProofFormGroup)">
    <div class="form-field row">
        <p class="form-field-heading col-xs-12">Proof Type</p>
        <mat-form-field class="col-xs-12">
            <mat-select placeholder="Select a residence proof"
                        formControlName="proofType"
                        (selectionChange)="onProofTypeChanged(residenceProofFormGroup)">
                <mat-option *ngFor="let documentType of addressProofTypes" [value]="documentType">
                    {{ AddressProofTypeModel.getDisplayableDocumentType(documentType) }}
                </mat-option>
                <mat-error>{{ getErrorMessage(residenceProofFormGroup.controls.proofType) }}</mat-error>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="form-field row" *ngIf="residenceProofFormGroup.controls.proofId">
        <p class="form-field-heading col-xs-12">Proof Number</p>
        <mat-form-field class="col-xs-12">
            <input matInput type="text"
                   placeholder="Enter  {{AddressProofTypeModel.getDisplayableDocumentType(residenceProofFormGroup.controls.proofType.value) }} number"
                   formControlName="proofId">
            <mat-error>{{ getErrorMessage(residenceProofFormGroup.controls.proofId) }}</mat-error>
        </mat-form-field>
    </div>

    <div *ngIf="residenceProofFormGroup.controls.proofType.value === AddressProofType.aadhaar" class="aadhaar-info">
        <ul>
            <li>Masked e-Aadhaar can be used as a Proof of Address only if your Aadhaar is linked to your mobile number.
                To verify if your mobile
                number is linked to your Aadhaar, please visit
                <a href="https://myaadhaar.uidai.gov.in/verify-email-mobile" target="_blank" rel="noopener">
                    https://myaadhaar.uidai.gov.in/verify-email-mobile</a>.
                If it is not linked, please do this by visiting your nearest Aadhaar enrolment center.
            </li>
            <li>In the upcoming pages we will give you quick guidelines on how to download a masked copy of your Aadhaar
                from
                UIDAI website. Click on "NEXT" button to proceed to upload Aadhaar as your address proof.
            </li>
        </ul>
    </div>

    <div class="form-field mt-5" id="aadhaar-linked-with-mobile">
        <p class="small-heading">Is your mobile linked with Aadhaar</p>
        <p class="secondary-text">This information would help us support you to electronically sign your loan documents
            post loan approval</p>
        <mat-button-toggle-group name="aadhaarLinkedWithMobile" formControlName="aadhaarLinkedWithMobile">
            <mat-button-toggle *ngFor="let answer of aadhaarLinkAnswers"
                               [value]="answer.value">{{ answer.displayName }}</mat-button-toggle>
        </mat-button-toggle-group>
        <mat-error class="small-text"
                   *ngIf="isFormSubmitted && residenceProofFormGroup.controls.aadhaarLinkedWithMobile.invalid">
            {{ getErrorMessage(residenceProofFormGroup.controls.aadhaarLinkedWithMobile) }}</mat-error>
    </div>

    <div class="row">
        <div class="col-xs-6">
            <button mat-stroked-button class="button-back primary" type="button" (click)="previousPage()">
                <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
            </button>
        </div>
        <div class="col-xs-6">
            <div class="pull-right">
                <app-forward-button class="button-forward" [isLoading]="shouldShowLoader">
                    NEXT
                </app-forward-button>
            </div>
        </div>
    </div>
</form>
